<template>
<v-container>
  <h2>
    分析を依頼する（お申込み）
  </h2>
  <br>
  <div class="mb-3 body-2">
    ジャパン・アナリストへ分析を依頼します。
    分析サンプルの登録が分析依頼の前提となっておりますので、登録を済ませていない場合はサンプル登録を先に実施してください。<br>
  </div>

    <div class="body-2" align="center">
      <v-card outlined class="pa-4" color="amber lighten-4" max-width="600px">
        <div class="body-2 mb-3">
          <v-icon>mdi-information-outline</v-icon>
          分析サンプルの登録のしかたはこちらのマニュアルをご確認ください
          </div>
        <div align="center">
          <v-btn small class="white--text" color="success" @click="showMan('manSampleEntry')">
            「分析サンプルを採取登録する」マニュアルを見る
          </v-btn>
        </div>
      </v-card>
    </div>

    <div class="my-8 mb-4">
      <h3>分析の依頼のしかた</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 my-4 body-2">
      メニューの「お申込み」をクリックします。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-sample-entry-01.png" width="70%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      「分析依頼」の採油済みサンプル一覧の中に依頼する予定のサンプルが載っていることを確認してください。<br>
      サンプル登録が確認できたら、「新しい分析依頼」ボタンをクリックしてください。分析依頼のお申込みフォームが開きます。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-analize-entry-01.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      「案件情報」を入力します。<br>
      「案件名」及び「お客様内注文番号」は任意入力です。請求書に記載いたしますので、お客様内で管理するための番号や案件が判別できるような案件名を入力すると便利に使えます。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-analize-entry-02.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      「報告書の宛先」を入力します。<br>
      分析・診断結果報告書の宛先として記載する情報です。登録済の宛先から選択してください。<br>
      登録済のリストに宛先がない場合は、「設定済でない報告書の宛先を入力する」スイッチをＯＮにして、個々の宛先を入力してください。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-analize-entry-03.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      「設定済でない報告書の宛先を入力する」スイッチを有効にした場合、下記の入力フォームに会社名、事業所名、部署名、ご担当者様氏名を入力ください。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-analize-entry-04.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      「報告書の送付先」を選択します。<br>
      登録済の宛先から選択してください。選択した宛先へ分析・診断結果報告書を送付いたします。<br>
      宛先リストに選択したい宛先が無い場合は、ジャパン・アナリスト担当営業までご連絡ください。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-analize-entry-05.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      「請求書／納品明細書の送付先」を選択します。<br>
      登録済の宛先から選択してください。選択した宛先へ請求書および納品明細書を送付いたします。<br>
      宛先リストに選択したい宛先が無い場合は、ジャパン・アナリスト担当営業までご連絡ください。<br>
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-analize-entry-06.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      分析依頼するサンプルを「採油済みサンプルリスト」より選択します。<br>
      登録済の宛先から選択してください。選択した宛先へ請求書および納品明細書を送付いたします。<br>
      報告書の宛先、送付先、請求書、及び納品明細書の送付先が同じ場合は、１件の依頼で複数のサンプルの分析をご依頼頂くことが可能です。<br>
      報告書の宛先、送付先、請求書、及び納品明細書の送付先が異なる場合は、お手数ですが別の分析依頼としてご依頼ください。<br>
      選択したサンプルの分析料金を表示します。<br>
      <span class="caption grey--text">※料金は標準価格です。</span>
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-analize-entry-07.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      分析依頼するサンプルが「採油済みサンプルリスト」に無い場合は、下記マニュアルを参照しサンプル登録を行ってください。<br>
    </div>

    <div class="body-2" align="center">
      <v-card outlined class="pa-4" color="amber lighten-4" max-width="600px">
        <div class="body-2 mb-3">
          <v-icon>mdi-information-outline</v-icon>
          分析サンプルの登録のしかたはこちらのマニュアルをご確認ください
          </div>
        <div align="center">
          <v-btn small class="white--text" color="success" @click="showMan('manSampleEntry')">
            「分析サンプルを採取登録する」マニュアルを見る
          </v-btn>
        </div>
      </v-card>
    </div>

    <div class="ml-4 mb-4 mt-8 body-2">
      サンプル毎にご希望の分析納期をご指定いただけます。<br>
      <span class="caption grey--text">※OilMatrixの混雑状況によってはご希望に添えない場合がございます。ご理解の程よろしくお願いいたします。</span>
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-analize-entry-08.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      「依頼内容を確認する」ボタンをクリックすると、確認画面が開きます。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-analize-entry-09.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      確認画面が開きます。<br>
      設定内容を確認のうえ、「分析・診断を依頼する」ボタンをクリックしてください
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-analize-entry-10.png" width="90%" class="my-2">
    </div>

    <div class="mt-8 mb-4">
      <v-card  outlined color="teal" class="mx-auto" max-width="90%">
        <v-card-title>
          <v-icon color="white">mdi-phone-forward</v-icon>
          <span class="white--text body-1 font-weight-light">申し込み内容の変更・キャンセルについて</span>          
        </v-card-title>
        <v-card-text class="body-2 white--text">
         お申込み内容について、変更やキャンセルがある場合は、お手数ですがジャパン・アナリストまでご連絡ください。
        </v-card-text>
        <v-btn rounded color="body-2 amber darken-1 font-weight-bold"  @click="openInquiry()" class="mx-2 mb-5">
          <v-icon class="mr-2">mdi-comment-question-outline  </v-icon>ご連絡・お問合わせ
        </v-btn>
      </v-card>
    </div>

    <div class="mb-4 mt-10">
      <h3>分析の依頼画面の項目説明</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      分析の依頼画面の各項目の説明です。
    </div>

    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="entryData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">必須</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in entryData" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td v-if="item.isRequire==true"><v-icon small color=success>mdi-check</v-icon></td>
              <td v-else></td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>

    <div class="my-4">
      <h3>サンプルリストの項目説明</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      サンプルリストの各項目の説明です。
    </div>
    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="sampleData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in sampleData" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>

</v-container>

</template>
<script>
export default {
    data: () => ({
//        inquiry_url: process.env.VUE_APP_INQUIRY_URL,
        inquiry_url: "https://www.japan-analysts.com/contact/",
        buttonName: '',
        entryData: [
          {
            name: '案件名',
            body: '任意入力です。お客様内で分析依頼を判別できるような名前を入力すると便利です。この情報は請求書に記載いたします。',
            isRequire: false
          },
          {
            name: 'お客様内注文番号',
            body: '任意入力です。お客様内で分析依頼を管理するための番号等を入力すると便利です。この情報は請求書に記載いたします。',
            isRequire: false
          },
          {
            name: '報告書宛先',
            body: '報告書宛先として記載する内容です。',
            isRequire: true
          },
          {
            name: '報告書送付先',
            body: '分析結果報告書の送付先です。ここで指定いただいた方へ報告書を送付します',
            isRequire: true
          },
          {
            name: '請求書／納品明細書送付先',
            body: '請求書および納品明細書の送付先です。',
            isRequire: true
          },
          {
            name: '分析サンプル',
            body: '採油済みのサンプルリストです。',
            isRequire: true
          },
          {
            name: '分析料金',
            body: '選択したサンプルの分析料金の合計が表示されます。',
            isRequire: false
          },

        ],
        sampleData: [
          {
            name: 'サンプル名',
            body: 'サンプル名として指定した内容が表示されます。',
          },
          {
            name: '機器ID',
            body: 'サンプルを採取したマイ機器IDが表示されます。',
          },
          {
            name: '採油日',
            body: 'ご依頼いただいたサンプルの採油日です',
          },
          {
            name: 'ボトル数',
            body: 'ご依頼いただいたサンプルのボトル数です',
          },
          {
            name: '分析料金',
            body: 'ご依頼いただいたサンプルの分析料金です。',
          },
          {
            name: '指定納期',
            body: 'サンプルごとに納期を指定できます。納期の指定をしていない場合は「指定無し」と表記されます。',
          },
        ],        
    }),
    methods: {
      showMan: async function(value) {
        var url = '/UserManual/' + value
        this.$router.push(url)        
      },
      openInquiry() {
          window.open(this.inquiry_url, '_blank')
      },
    }
}
</script>

